@if (showGrid()) {
<div class="planet-grid-panel">
  <h3 [class]="sideLabelClass()">{{ sideLabel() }}</h3>

  <hd-incarnation-cross
    [activations]="activations()"
    [side]="side()"
    [renderState]="renderState()"
    [colorConfig]="colorConfig()"
    [showGeneKeys]="showGeneKeys()"
    [showHdKeynotes]="showHdKeynotes()"
    [visualizationMode]="effectiveVisualizationMode()"
    [density]="density()"
    [baseHoverTargetGates]="baseHoverTargetGates()"
    (blockClicked)="planetActivationClicked.emit($event)"
    (phsBlockClicked)="phsBlockClicked.emit($event)"
  ></hd-incarnation-cross>

  <hd-life-cross
    [activations]="activations()"
    [side]="side()"
    [renderState]="renderState()"
    [colorConfig]="colorConfig()"
    [showHdKeynotes]="showHdKeynotes()"
    [visualizationMode]="effectiveVisualizationMode()"
    [density]="density()"
    [oppositeLpsLineToGates]="oppositeLpsLineToGates()"
    [baseHoverTargetGates]="baseHoverTargetGates()"
    (blockClicked)="planetActivationClicked.emit($event)"
    (phsBlockClicked)="phsBlockClicked.emit($event)"
  ></hd-life-cross>

  @if (resonanceMode()) {
    <hd-resonance-lunar-planetary-square
      class="resonance-lps-section"
      [activations]="activations()"
      [side]="side()"
      [renderState]="renderState()"
      [colorConfig]="colorConfig()"
      [matchLines]="oppositeNodeLines()"
      [profileLines]="profileLines()"
      (blockClicked)="planetActivationClicked.emit($event)"
    ></hd-resonance-lunar-planetary-square>
  } @else {
    <hd-lunar-planetary-square
      [activations]="activations()"
      [side]="side()"
      [renderState]="renderState()"
      [colorConfig]="colorConfig()"
      [showGeneKeys]="showGeneKeys()"
      [showHdKeynotes]="showHdKeynotes()"
      [density]="density()"
      [matchLines]="oppositeNodeLines()"
      [profileLines]="profileLines()"
      (blockClicked)="planetActivationClicked.emit($event)"
    ></hd-lunar-planetary-square>
  }

</div>

<!-- Astro posities: tussen het gridpaneel en de statistieken, op dezelfde breedte (spec 2026-10-06). -->
<hd-astro-points
  class="astro-points-slot"
  [side]="side()"
  [chiron]="astroChiron()"
  [points]="astroPoints()"
  [density]="density()"
  (pointClicked)="astroPointClicked.emit($event)"
/>
}

@if (showSideStats() && side() === 'design') {
  <div class="side-stats-combined">
    <hd-line-stats
      class="line-stats-slot"
      [planetaryActivations]="allActivations()"
      [renderState]="renderState()"
      [overallRenderState]="statsOverallRenderState()"
      [selectedActivations]="selectedStatsActivations()"
      [selectedSide]="statsSide()"
      [selectedColor]="selectedStatsColor()"
    />
    <div class="circuit-stats-slot">
      <hd-circuit-stats
        [planetaryActivations]="allActivations()"
        [selectedActivations]="selectedStatsActivations()"
        [selectedSide]="statsSide()"
        [selectedColor]="selectedStatsColor()"
      />
      <!-- Chiron (D + P) rechtsonder: in de grid zelf is geen plaats. Geen activatie. -->
      @if (chironDesign() || chironPersonality()) {
        <hd-chiron-stats
          class="chiron-stats-slot"
          [design]="chironDesign()"
          [personality]="chironPersonality()"
          (chironClicked)="chironClicked.emit($event)"
        />
      }
    </div>
  </div>
}
